<div class="reviews-page-container">
  <!-- Main page header -->
  <div class="flex">
    <div class="header-parent-title">
      <div class="header-child-title">Your Reviews.</div>
      <!-- Export UI lives on the Google Reviews tab. -->
    </div>
  </div>



  <!-- Tab menu-->
  <!-- <p-tabMenu class="tabs-menu" [model]="tabItems" [activeItem]="activeItem">
    <ng-template pTemplate="item" let-item let-i="index">
      <div class="tabs-style">{{ item.label }}</div>
    </ng-template>
  </p-tabMenu> -->
  <ng-container *ngIf="tabItems.length">
      
    <rs-page-tabs [tabItems]="tabItems" (tabSelected)="activeItem = $event"> </rs-page-tabs>
    <div *ngIf="activeItem.label == reviewTabs.HOME">
    <app-reviews-home></app-reviews-home>
  </div>

    <div *ngIf="activeItem.label == reviewTabs.METRICS"><app-metrics-tab></app-metrics-tab></div>

    <div *ngIf="activeItem.label == reviewTabs.REVIEWS"><app-google-reviews-tab></app-google-reviews-tab></div>

    <div *ngIf="activeItem.label == reviewTabs.OTHER_REVIEWS">
      <p-selectButton
        class="other-reviews-switcher"
        [options]="reviewTypeOptions"
        [(ngModel)]="selectedReviewType"
        optionLabel="label"
        optionValue="value"
      ></p-selectButton>
      <app-pandio-reviews-tab [reviewType]="selectedReviewType"></app-pandio-reviews-tab>
    </div>
  </ng-container>

</div>
